﻿{
  "community": {
    "name": "Community",
    "shortDescription": "Ein einzelnes Konto mit kostenlosen Aktivitäten",
    "features": [
      "Aktivitäten finden und mit anderen teilen",
      "Unbegrenzter Cloudspeicher für Aktivitäten",
      "Zugang zu Premium-Aktivitäten"
    ],
    "price": "Kostenlos",
    "termName": "Lebenszeit"
  },
  "personal": {
    "name": "Einzellizenz",
    "shortDescription": "Ein einzelnes Konto mit benutzerdefinierten Aktivitäten",
    "features": [
      "Aktivitäten online erstellen und bearbeiten",
      "Einschließlich persönlicher Wiedergabeliste",
      "Zugriff auf Aktivitäten für unterwegs"
    ]
  },
  "professional": {
    "name": "Expertenlizenz",
    "shortDescription": "Ein einzelnes Konto mit mehreren Lernenden",
    "features": [
      "Zuweisungen an Lernende verwalten",
      "Fortschritte der Lernenden überwachen",
      "Mit Teammitgliedern zusammenarbeiten"
    ]
  },
  "organization": {
    "name": "Organisation",
    "shortDescription": "Mehrere Konten mit mehreren Lernenden",
    "features": [
      "Lehrerverwaltung",
      "Berichterstellung auf Organisationsebene",
      "Datenschutzeinstellungen auf Enterprise-Niveau"
    ],
    "price": "Kontaktiere uns",
    "termName": "Laufzeit von 1–5 Jahren"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Vorschau für Desktop-Editor",
    "note": "Testen Sie es <1>$t(common:action.free)</1> 30 Tage lang!",
    "price": "Kostenlos",
    "termName": "30-tägiger Test",
    "footerNote": "1 Installation"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Vollständiger Desktop-Editor",
    "note": "",
    "termName": "Vollversion",
    "footerNote": "2 Installationen pro Benutzer"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Mehrere Lizenzen für Organisationen",
    "note": "",
    "price": "Kontaktiere uns",
    "termName": "Mengenrabatte",
    "footerNote": "2 Installationen pro Benutzer"
  }
}
